import { useSyncExternalStore } from 'react'

// Reads a CSS media query from React.
//
// The docs layout drops columns at breakpoints, and the page tree is the one
// that cannot simply vanish — below its breakpoint it becomes a disclosure, and
// whether it starts open is a rendering decision, not a styling one. CSS cannot
// set the `open` attribute, so the query has to be readable here.
//
// `useSyncExternalStore` rather than an effect + state: it subscribes without a
// render-then-correct pass, so the tree does not flash open on a narrow viewport.

export const useMediaQuery = (query: string): boolean =>
  useSyncExternalStore(
    onChange => {
      // `matchMedia` is absent in some test environments; treat it as "no match"
      // rather than letting a docs page fail to render.
      const list = window.matchMedia?.(query)
      if (!list) return () => undefined
      list.addEventListener('change', onChange)
      return () => list.removeEventListener('change', onChange)
    },
    () => window.matchMedia?.(query).matches ?? false,
    // Server snapshot: nothing renders this on a server today, but the hook must
    // still answer if something ever does.
    () => false
  )
